import React from "react"
import { Button } from "antd"
import { PRIMARY_BTN_STYLE, OUTLINE_BTN_STYLE } from "./constants"

const SummaryCard = ({ wizardMeta, answered, onRespond }) => {
  const { collected, remaining } = wizardMeta

  return (
    <div className="wizard-summary-card" style={{ marginTop: 8 }}>
      <div
        style={{
          background: "#f8f4f0", borderLeft: "3px solid #2f9e8f", borderRadius: "0 4px 4px 0", padding: "10px 14px", marginBottom: 10, fontSize: 13,
        }}
      >
        <div style={{ display: "block", margin: "0 0 6px" }}>
          <strong>Domain:</strong>
          {` ${collected.domain} | `}
          <strong>Tier:</strong>
          {` ${collected.tier}`}
        </div>
        <div style={{ display: "block", margin: "0 0 6px" }}>
          <strong>Grades:</strong>
          {` ${(collected.grades || []).join(", ") || "N/A"} | `}
          <strong>Years:</strong>
          {` ${collected.years}`}
        </div>
        <div style={{ display: "block", margin: "0 0 6px" }}>
          <strong>Name:</strong>
          {` ${collected.name}`}
        </div>
        <div style={{ display: "block", margin: "0 0 6px" }}>
          <strong>Description:</strong>
          {` ${collected.description || "(none)"}`}
        </div>
        <div style={{ display: "block", margin: "0 0 6px" }}>
          <strong>Indicators:</strong>
          {` ${(collected.indicators || []).join(", ") || "None"}`}
        </div>
        <div style={{ display: "block", margin: 0 }}>
          <strong>Data:</strong>
          {` ${collected.dataCollection || "N/A"}`}
        </div>
      </div>

      {!answered && (
        <div style={{ display: "flex", gap: 8, marginBottom: 6 }}>
          <Button style={PRIMARY_BTN_STYLE} onClick={() => onRespond({ action: "save" })}>
            Save to Matrix ✓
          </Button>
          <Button style={OUTLINE_BTN_STYLE} onClick={() => onRespond({ action: "restart" })}>
            Make changes
          </Button>
        </div>
      )}

      {typeof remaining === "number" && remaining > 0 && (
        <p style={{ margin: 0, fontSize: 12, color: "#2f9e8f" }}>
          {`${remaining} more activit${remaining === 1 ? "y" : "ies"} remaining`}
        </p>
      )}
    </div>
  )
}

export default SummaryCard
